export default __webpack_public_path__ + "static/media/Angon.fd9e19d2.ttf";